"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateItemsFromScheduledPayments = exports.generateItemsFromOrderDeadlines = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _booking = require("./booking");
var generateItemsFromOrderDeadlines = exports.generateItemsFromOrderDeadlines = function generateItemsFromOrderDeadlines(order, isOnBookingPage) {
  var amountPaid = (0, _booking.getPaidAmount)(order);
  var orderTotal = order.gross;
  var amountPaidPercentage = amountPaid ? amountPaid / orderTotal * 100 : 0;
  var orderDeadlinesArray = order.orderDeadlines || [];
  var type = 'deadline';
  var items = [];
  if (!orderDeadlinesArray.length) return items;
  if (isOnBookingPage) {
    // First item must be amount paid if there was something paid
    if (amountPaid) {
      items.push({
        width: amountPaidPercentage,
        amount: amountPaid / 100 || 0,
        status: 'paid',
        type: 'payment',
        tooltipTitle: "Paid (".concat(Math.round(amountPaidPercentage), "%)"),
        dueDate: null,
        bookingPage: isOnBookingPage
      });
    }
    // here will take in account order deadlines
    var accDeadlinePercentage = 0;
    var accFilledWidth = amountPaidPercentage;
    orderDeadlinesArray.forEach(function (deadline) {
      var isOverdue = (0, _moment["default"])(deadline.dueDate).isBefore();
      var itemWidth = deadline.percent + accDeadlinePercentage - accFilledWidth;
      if (itemWidth > 0) {
        items.push({
          width: itemWidth,
          status: isOverdue ? 'overdue' : 'ok',
          type: type,
          tooltipTitle: "".concat(isOverdue ? 'Overdue ' : '').concat(type, " (").concat(Math.round(itemWidth), "%)"),
          amount: orderTotal * (itemWidth / 100) / 100,
          dueDate: deadline.dueDate,
          bookingPage: isOnBookingPage
        });
        accFilledWidth += itemWidth;
      }
      accDeadlinePercentage += deadline.percent;
    });
  } else {
    // in funnel on payment step
    orderDeadlinesArray.forEach(function (deadline, i) {
      return items.push({
        width: deadline.percent,
        status: deadline.status,
        type: type,
        tooltipTitle: "".concat(i === 0 ? 'Deposit' : type, " (").concat(deadline.percent, "%)"),
        amount: deadline.amount / 100,
        dueDate: deadline.dueDate,
        bookingPage: isOnBookingPage
      });
    });
  }
  return items;
};
var generateItemsFromScheduledPayments = exports.generateItemsFromScheduledPayments = function generateItemsFromScheduledPayments(order, isOnBookingPage, scheduledPaymentsData) {
  var amountPaid = (0, _booking.getPaidAmount)(order);
  var orderTotal = order.gross;
  var amountPaidPercentage = amountPaid ? amountPaid / orderTotal * 100 : 0;
  var scheduledPayments = order.payments.filter(function (payment) {
    return payment.status === 'scheduled';
  });
  var type = 'payment';
  var items = [];
  if (isOnBookingPage) {
    // First item must be amount paid if there was something paid
    if (amountPaid) {
      items.push({
        width: amountPaidPercentage,
        amount: amountPaid / 100 || 0,
        status: 'paid',
        type: type,
        tooltipTitle: 'Paid',
        dueDate: null,
        bookingPage: isOnBookingPage
      });
    }
    if (scheduledPayments.length) {
      scheduledPayments.forEach(function (payment) {
        var paymentAmount = payment.amountRegistered / 100;
        var widthPercentage = paymentAmount / (orderTotal / 100) * 100;
        return items.push({
          width: widthPercentage,
          status: payment.status,
          type: type,
          tooltipTitle: 'Scheduled payment',
          amount: paymentAmount,
          dueDate: payment.dateScheduled,
          bookingPage: isOnBookingPage
        });
      });
    }
  } else {
    // in funnel on payment step
    var orderDeadlinesArray = order.orderDeadlines || [];
    var firstItemWidth = 0;
    if (orderDeadlinesArray.length) {
      // first item we take from first deadline as this will be what user is about to pay
      var firstOrderDeadline = orderDeadlinesArray[0];
      firstItemWidth = firstOrderDeadline.percent;
      items.push({
        width: firstItemWidth,
        status: firstOrderDeadline.status,
        type: type,
        tooltipTitle: "Deposit (".concat(firstItemWidth, "%)"),
        amount: firstOrderDeadline.amount / 100,
        dueDate: null,
        bookingPage: isOnBookingPage
      });
    }
    if (scheduledPaymentsData.length) {
      var leftToPayPercentage = 100 - firstItemWidth;
      var widthOfScheduledPayment = leftToPayPercentage / scheduledPaymentsData.length;
      scheduledPaymentsData.forEach(function (payment) {
        return items.push({
          width: widthOfScheduledPayment,
          status: 'scheduled',
          type: type,
          tooltipTitle: 'Scheduled payment',
          amount: payment.amount / 100,
          dueDate: payment.dateScheduled,
          bookingPage: isOnBookingPage
        });
      });
    }
  }
  return items;
};